var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "usa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Baby-Odin-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Dropdown-Copy-2",
    transform: "translate(-33.000000, -131.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "usa",
    transform: "translate(33.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0.888888889 C21,0.397777778 20.6084375,0 20.125,0 L8.75,0 L8.75,8.88888889 L0,8.88888889 L0,15.1111111 C0,15.6022222 0.3915625,16 0.875,16 L20.125,16 C20.6084375,16 21,15.6022222 21,15.1111111 L21,0.888888889 Z",
    id: "Path",
    fill: "#B41F30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 9,
    y: 2,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 9,
    y: 5,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6E6E6",
    points: "0 9 0 11 21 11 21 9 8.75 9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 0,
    y: 12,
    width: 21,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9 L0,9 L0,0.9 C0,0.40275 0.40275,0 0.9,0 L9,0 L9,9 Z",
    id: "Path",
    fill: "#00256A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "4 3 3.70379036 3.65832531 3 3.65832531 3.51474029 4.20692974 3.32475433 5 4 4.60635226 4.67524567 5 4.48525971 4.20692974 5 3.65832531 4.29527375 3.65832531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "1.99976597 1 1.70395507 1.65832531 1 1.65832531 1.5143927 2.20692974 1.32436227 3 1.99976597 2.60635226 2.67563773 3 2.48513925 2.20692974 3 1.65832531 2.29510882 1.65832531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "7.00023403 1 7.29604493 1.65832531 8 1.65832531 7.4856073 2.20692974 7.67563773 3 7.00023403 2.60635226 6.32436227 3 6.51486075 2.20692974 6 1.65832531 6.70489118 1.65832531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "1.99976597 8 1.70395507 7.34167469 1 7.34167469 1.5143927 6.79307026 1.32436227 6 1.99976597 6.39364774 2.67563773 6 2.48513925 6.79307026 3 7.34167469 2.29510882 7.34167469"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "7.00023403 8 7.29604493 7.34167469 8 7.34167469 7.4856073 6.79307026 7.67563773 6 7.00023403 6.39364774 6.32436227 6 6.51486075 6.79307026 6 7.34167469 6.70489118 7.34167469"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.82b3f73f.svg";
export { ForwardRef as ReactComponent };